export interface ReconciliationSummaryTO {
  title: string;
  body: string[];
}

export const toReconciliationSummaryTO = (
  data: any,
): ReconciliationSummaryTO => {
  const body = data?.content?.split('\n') || [];
  return {
    title: data.title,
    body,
  };
};
